import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum ProductLevelIds {
  KIT = 1,
  ITEM = 2,
}

export function getProductLevels(): ISelectItem[] {
  return [
    { id: ProductLevelIds.KIT, label: 'Kit' },
    { id: ProductLevelIds.ITEM, label: 'Item' },
  ]
}

export const getProductLevelByLabel = getItemByLabelFactory(getProductLevels)

export const getProductLevelById = getItemByIdFactory(getProductLevels)
